var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FileType } from './types';
export const getFileType = (file) => {
    const { type } = file;
    if (type.startsWith('image')) {
        return FileType.Image;
    }
    if (type.startsWith('video')) {
        return FileType.Video;
    }
    if (type.includes('application/pdf')) {
        return FileType.PDF;
    }
    return FileType.File;
};
export const uploadFile = (file, url, method) => __awaiter(void 0, void 0, void 0, function* () {
    return fetch(url, {
        method,
        headers: new Headers({
            'Content-Type': file.type,
        }),
        body: file,
    });
});
